import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { StoreAssetEditorInformation } from 'app/pages/store-management/designer/store-designer-assets.component';
import {
    DeleteStoreDesignerAssetInput,
    GraphDotnetService,
    graphql,
    MediaclipMutationDeleteStoreDesignerAssetArgs,
    MediaclipMutationUpdateStoreDesignerAssetArgs,
    StoreDesignerAsset,
    UpdateStoreDesignerAssetInput,
} from 'app/shared/graph';

type DesignerAssetDto = {
    filename: string;
    url: string;
    publicUrl: string;
    mimeType: string;
}

@Injectable({ providedIn: 'root' })
export class StoreDesignerAssetsService {
    private readonly graphDotnetService = inject(GraphDotnetService);

    uploadAssetEditorFile(input: UpdateStoreDesignerAssetInput): Observable<StoreDesignerAsset> {
        return this.graphDotnetService.mutate<MediaclipMutationUpdateStoreDesignerAssetArgs>(
            graphql`
                mutation updateStoreDesignerCustomAsset($input: UpdateStoreDesignerAssetInput!) {
                    updateStoreDesignerAsset(input: $input) {
                        contentHash
                        filename
                        mimeType
                        url
                        publicUrl
                    }
                }
            `,
            { input },
        ).pipe(
            map((result) => result.updateStoreDesignerAsset),
        );
    }

    deleteAssetEditorFile(input: DeleteStoreDesignerAssetInput): Observable<void> {
        return this.graphDotnetService.mutate<MediaclipMutationDeleteStoreDesignerAssetArgs>(
            graphql`
                mutation deleteStoreDesignerAsset($input: DeleteStoreDesignerAssetInput!) {
                    deleteStoreDesignerAsset(input: $input)
                }
            `,
            { input },
        ).pipe(
            map((result) => result.deleteStoreDesignerAsset),
        );
    }

    listAssets(storeId: string): Observable<StoreAssetEditorInformation[]> {   return this.graphDotnetService.query(
        graphql`
                query storeDesignerAssets($storeId: String!) {
                    store(id: $storeId) {
                        designerAssets {
                            filename
                            mimeType
                            contentHash
                            url
                            publicUrl
                        }
                    }
                }
            `,
        { storeId },
    ).pipe(map(r => (r.store.designerAssets as DesignerAssetDto[]).map(a => this.toAssetEditorInformation(a))));
    }

    private toAssetEditorInformation(dto: DesignerAssetDto): StoreAssetEditorInformation {
        return {
            ...dto,
        };
    }
}
